import { createReducer } from 'utilities';
import * as TYPES from './constants';
import { LANG_NAME, LANGUAGES } from 'CONSTANTS';
import { mergeDedupe } from 'utilities';

function reduceTranslation(state, keys, language, translation) {
  return (acc, key) => {
    acc[key] = {
      ...state.translations[key] || {},
      [language]: translation[key]
    };
    return acc;
  }
}

// consider only languages declared in LANGUAGES;
// take lang from localStorage / navigator / default (en);
const navigatorLang = navigator && navigator.language.split('-')[0];
const initialState = {
  language: LANGUAGES.find(el => el === (localStorage[LANG_NAME] || navigatorLang)) || 'en',
  translations: {},
  loadedTranslations: [],
  modal: {
    open: null,
    extra: undefined
  },
};

const reducer = createReducer(initialState, {
  [TYPES.CHANGE_LANGUAGE](state, { language, translation }) {
    const keys = Object.keys(translation);
    return {
      ...state,
      language,
      loadedTranslations: mergeDedupe([ ...state.loadedTranslations, language ]),
      translations: {
        ...state.translations,
        ...keys.reduce(reduceTranslation(state, keys, language, translation), {})
      }
    }
  },
  [TYPES.MODAL_OPEN](state, action) {
    const { id, extra } = action;
    return {
      ...state,
      modal: {
        open: id,
        extra
      }
    }
  },
  [TYPES.MODAL_CLOSE](state) {
    return {
      ...state,
      modal: {
        open: null,
        extra: undefined
      }
    }
  },
});

export default reducer;




// WEBPACK FOOTER //
// ./src/ducks/ui/reducer.js